import { gql } from "@apollo/client";

import TopicNodeFragment from "./topic-node-fragment";

export default gql`
  ${TopicNodeFragment}
  mutation createTopicNewPageMutation(
    $topicId: Int
    $meetingId: Int
    $afterTopicId: Int
    $beforeTopicId: Int
    $includesIndividualNotes: Boolean
    $includesSharedNotes: Boolean
    $title: String
    $description: String
    $discussionNotes: JSONString
    $individualNotes: JSONString
  ) {
    createOrUpdateTopic(
      topicId: $topicId
      afterTopicId: $afterTopicId
      beforeTopicId: $beforeTopicId
      includesIndividualNotes: $includesIndividualNotes
      includesSharedNotes: $includesSharedNotes
      meetingId: $meetingId
      title: $title
      description: $description
      discussionNotes: $discussionNotes
      individualNotes: $individualNotes
    ) {
      topic {
        ...TopicNodeNewPageFragment
      }
    }
  }
`;
